import React from "react";
import {
  FormField,
  FormInput,
  FormSelect,
  FormTextarea,
  Modal,
  ModalFooterButtons,
} from "../../../../components/Modal";

export interface AddInformationTypeDialogProps {
  open: boolean;
  onClose: () => void;
  handleAddInfoType: () => void;
  addingInfoType: boolean;
  infoTypeForm: {
    title: string;
    description: string;
    confidentiality: string;
    integrity: string;
    availability: string;
  };
  setInfoTypeForm: React.Dispatch<
    React.SetStateAction<{
      title: string;
      description: string;
      confidentiality: string;
      integrity: string;
      availability: string;
    }>
  >;
}

export function AddInformationTypeDialog({
  open,
  onClose,
  handleAddInfoType,
  addingInfoType,
  infoTypeForm,
  setInfoTypeForm,
}: AddInformationTypeDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add Information Type"
      description="Register an information type processed by this system"
      size="md"
      footer={
        <ModalFooterButtons
          onCancel={onClose}
          onSubmit={handleAddInfoType}
          submitLabel={addingInfoType ? "Saving" : "Save"}
          submitDisabled={
            !infoTypeForm.title ||
            !infoTypeForm.confidentiality ||
            !infoTypeForm.integrity ||
            !infoTypeForm.availability ||
            addingInfoType
          }
        />
      }
    >
      <FormField label="Title" required>
        <FormInput
          placeholder="e.g. Personally Identifiable Information"
          value={infoTypeForm.title}
          onChange={(v) => setInfoTypeForm((f) => ({ ...f, title: v }))}
        />
      </FormField>
      <FormField label="Description">
        <FormTextarea
          placeholder="Description of this information type"
          value={infoTypeForm.description}
          onChange={(v) => setInfoTypeForm((f) => ({ ...f, description: v }))}
          rows={2}
        />
      </FormField>
      <div className="grid grid-cols-3 gap-3">
        <FormField label="Confidentiality" required>
          <FormSelect
            options={[
              { value: "low", label: "Low" },
              { value: "moderate", label: "Moderate" },
              { value: "high", label: "High" },
            ]}
            placeholder="Select"
            value={infoTypeForm.confidentiality}
            onChange={(v) =>
              setInfoTypeForm((f) => ({ ...f, confidentiality: v }))
            }
          />
        </FormField>
        <FormField label="Integrity" required>
          <FormSelect
            options={[
              { value: "low", label: "Low" },
              { value: "moderate", label: "Moderate" },
              { value: "high", label: "High" },
            ]}
            placeholder="Select"
            value={infoTypeForm.integrity}
            onChange={(v) => setInfoTypeForm((f) => ({ ...f, integrity: v }))}
          />
        </FormField>
        <FormField label="Availability" required>
          <FormSelect
            options={[
              { value: "low", label: "Low" },
              { value: "moderate", label: "Moderate" },
              { value: "high", label: "High" },
            ]}
            placeholder="Select"
            value={infoTypeForm.availability}
            onChange={(v) =>
              setInfoTypeForm((f) => ({ ...f, availability: v }))
            }
          />
        </FormField>
      </div>
    </Modal>
  );
}
